(function () {
  'use strict';

  let angular = window.angular;

  GisRouter.$inject = ['$stateProvider'];

  angular.module('app').config(GisRouter);

  function GisRouter($stateProvider) {
    $stateProvider
      .state('member.project.gis', {
        url: '/gis',
        redirectTo: 'member.project.gis.home',
        template: '<ui-view></ui-view>',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'GIS',
        },
        resolve: {
          dependencies: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([window.assetsPath + '/js/app/gis.module.min.js']);
            },
          ],
          hasTool: [
            'tools',
            'AppUtils',
            function (tools, utils) {
              const hasTool = tools.find((tool) => tool.module === 'xompassGIS');
              if (!hasTool) {
                throw utils.getHTTPError(new Error('Not allowed'), {
                  redirectTo: 'member.customer.invalidTool',
                  params: { tool: 'xompassGIS' },
                });
              }
            },
          ],
        },
      })
      .state('member.project.gis.home', {
        url: '/',
        component: 'gisHome',
        authenticated: true,
        resolve: {
          gis: [
            'Customer',
            'Manager',
            '$transition$',
            function (Customer, Manager, $transition$) {
              let params = $transition$.params();
              return Customer.prototype$__get__projects__gis({
                id: Manager.getCachedCurrent().customerId,
                nk: params.projectId,
                filter: {
                  where: { type: 'GENERIC' },
                },
              }).$promise;
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{"general.gallery" | translate}}',
        },
      })
      .state('member.project.gis.new', {
        url: '/new',
        component: 'gisEditor',
        authenticated: true,
        resolve: {
          dependencies: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/vendors/gmap-vendors.min.js',
                window.assetsPath + `/js/vendors/chart-vendors-${style}.min.js`,
              ]);
            },
          ],
        },
        ncyBreadcrumb: {
          label: 'New',
        },
      })
      .state('member.project.gis.show', {
        url: '/:gisId',
        component: 'gisShow',
        redirectTo: 'member.project.gis.show.viewer',
        authenticated: true,
        resolve: {
          dependencies: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/vendors/gmap-vendors.min.js',
                window.assetsPath + `/js/vendors/chart-vendors-${style}.min.js`,
              ]);
            },
          ],
          gisModel: [
            'Customer',
            'Manager',
            '$transition$',
            'AppUtils',
            function (Customer, Manager, $transition$, utils) {
              let params = $transition$.params();
              return loadGIS(
                Customer,
                Manager.getCachedCurrent().customerId,
                params.projectId,
                params.gisId,
                utils
              );
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{$resolve.gisModel.name}}',
        },
      })
      .state('member.project.gis.show.viewer', {
        url: '/viewer',
        component: 'gisViewer',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Viewer',
        },
      })
      .state('member.project.gis.show.editor', {
        url: '/editor',
        component: 'gisEditor',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Editor',
        },
      })

      // WILDFIRE

      .state('member.project.wildfire', {
        url: '/wildfire',
        redirectTo: 'member.project.wildfire.home',
        template: '<ui-view></ui-view>',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Wildfire',
        },
        resolve: {
          hasTool: [
            'tools',
            'AppUtils',
            function (tools, utils) {
              const hasTool = tools.find((tool) => tool.module === 'xompassWildfireGis');
              if (!hasTool) {
                throw utils.getHTTPError(new Error('Not allowed'), {
                  redirectTo: 'member.customer.invalidTool',
                  params: { tool: 'xompassWildfireGis' },
                });
              }
            },
          ],
        },
      })
      .state('member.project.wildfire.home', {
        url: '/',
        component: 'wildFireHome',
        authenticated: true,
        resolve: {
          gis: [
            'Customer',
            'Manager',
            '$transition$',
            function (Customer, Manager, $transition$) {
              let params = $transition$.params();
              return Customer.prototype$__get__projects__gis({
                id: Manager.getCachedCurrent().customerId,
                nk: params.projectId,
                filter: {
                  where: { type: 'WILDFIRE' },
                },
              }).$promise;
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{"general.gallery" | translate}}',
        },
      })
      .state('member.project.wildfire.new', {
        url: '/new',
        component: 'wildFireEditor',
        authenticated: true,
        resolve: {
          dependencies: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/vendors/gmap-vendors.min.js',
                window.assetsPath + `/js/vendors/chart-vendors-${style}.min.js`,
              ]);
            },
          ],
        },
        ncyBreadcrumb: {
          label: 'New',
        },
      })
      .state('member.project.wildfire.show', {
        url: '/:gisId',
        component: 'wildFireShow',
        redirectTo: 'member.project.wildfire.show.hazard',
        authenticated: true,
        resolve: {
          dependencies: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/vendors/gmap-vendors.min.js',
                window.assetsPath + `/js/vendors/chart-vendors-${style}.min.js`,
              ]);
            },
          ],
          gisModel: [
            'Customer',
            'Manager',
            '$transition$',
            'AppUtils',
            function (Customer, Manager, $transition$, utils) {
              const params = $transition$.params();
              return loadGIS(
                Customer,
                Manager.getCachedCurrent().customerId,
                params.projectId,
                params.gisId,
                utils
              );
            },
          ],
          assets: [
            'Customer',
            'Manager',
            'gisModel',
            (Customer, Manager, gisModel) => {
              return loadGISAssets(Customer, Manager.getCachedCurrent().customerId, gisModel);
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{$resolve.gisModel.name}}',
        },
      })
      .state('member.project.wildfire.show.hazard', {
        url: '/hazard',
        component: 'wildFireHazard',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Hazard',
        },
      })
      .state('member.project.wildfire.show.monitoring', {
        url: '/monitoring',
        component: 'wildFireMonitoring',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Monitoring',
        },
      })
      .state('member.project.wildfire.show.editor', {
        url: '/editor',
        component: 'wildFireViewer',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Editor',
        },
      })

      // FIBER
      .state('member.project.fiber', {
        url: '/fiber',
        redirectTo: 'member.project.fiber.home',
        template: '<ui-view></ui-view>',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Optical Fiber GIS',
        },
        resolve: {
          hasTool: [
            'tools',
            'AppUtils',
            function (tools, utils) {
              const hasTool = tools.find((tool) => tool.module === 'xompassOpticalFiberGis');
              if (!hasTool) {
                throw utils.getHTTPError(new Error('Not allowed'), {
                  redirectTo: 'member.customer.invalidTool',
                  params: { tool: 'xompassOpticalFiberGis' },
                });
              }
            },
          ],
        },
      })
      .state('member.project.fiber.home', {
        url: '/',
        component: 'fiberHome',
        authenticated: true,
        resolve: {
          gis: [
            'Customer',
            'Manager',
            '$transition$',
            function (Customer, Manager, $transition$) {
              let params = $transition$.params();
              return Customer.prototype$__get__projects__gis({
                id: Manager.getCachedCurrent().customerId,
                nk: params.projectId,
                filter: {
                  where: { type: 'OPTICAL_FIBER' },
                },
              }).$promise;
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{"general.gallery" | translate}}',
        },
      })
      .state('member.project.fiber.new', {
        url: '/new',
        component: 'fiberEditor',
        authenticated: true,
        resolve: {
          dependencies: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/vendors/gmap-vendors.min.js',
                window.assetsPath + `/js/vendors/chart-vendors-${style}.min.js`,
              ]);
            },
          ],
        },
        ncyBreadcrumb: {
          label: 'New',
        },
      })
      .state('member.project.fiber.show', {
        url: '/:gisId',
        component: 'fiberShow',
        redirectTo: 'member.project.fiber.show.viewer',
        authenticated: true,
        resolve: {
          dependencies: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/vendors/gmap-vendors.min.js',
                window.assetsPath + `/js/vendors/chart-vendors-${style}.min.js`,
              ]);
            },
          ],
          gisModel: [
            'Customer',
            'Manager',
            '$transition$',
            'AppUtils',
            function (Customer, Manager, $transition$, utils) {
              const params = $transition$.params();
              return loadGIS(
                Customer,
                Manager.getCachedCurrent().customerId,
                params.projectId,
                params.gisId,
                utils
              );
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{$resolve.gisModel.name}}',
        },
      })
      .state('member.project.fiber.show.viewer', {
        url: '/viewer',
        component: 'fiberViewer',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Viewer',
        },
      })
      .state('member.project.fiber.show.editor', {
        url: '/editor',
        component: 'fiberEditor',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Editor',
        },
      });

    function loadGIS(Customer, customerId, projectId, gisId, utils) {
      const redirect = {
        WILDFIRE: 'member.project.wildfire.home',
        GENERIC: 'member.project.gis.home',
        FIBER: 'member.project.fiber.home',
      };

      if (!gisId) {
        throw utils.getHTTPError(new Error('GIS ID required'), {
          redirectTo: redirect[type],
          params: { customerId: customerId, projectId: projectId },
        });
      }

      return Customer.prototype$__get__projects__gis({
        id: customerId,
        nk: projectId,
        filter: {
          where: { id: gisId },
          include: { relation: 'layers', scope: { include: 'features' } },
        },
      })
        .$promise.then((result) => {
          return result[0];
        })
        .catch((err) => {
          console.log(err);
          throw utils.getHTTPError(err, {
            redirectTo: redirect[type],
            params: { customerId: customerId, projectId: projectId },
          });
        });
    }

    function loadGISAssets(Customer, customerId, gis) {
      const assetIds = [];
      gis.layers.forEach((layer) => {
        layer.features.forEach((feature) => {
          if (!feature.assetId) {
            return;
          }
          assetIds.push(feature.assetId);
        });
      });
      return Customer.assets({
        id: customerId,
        filter: {
          where: { id: { inq: assetIds } },
          include: ['sensors', 'assetStates', 'currentState'],
          fields: {
            _token: false,
            _config: false,
            created: false,
            deleted: false,
            modified: false,
            path: false,
            customerId: false,
            projectId: false,
          },
        },
      }).$promise;
    }
  }
})();
